import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

import { AlertModalService } from "../modals";

const TIMEOUT_MS = 250;
const NUMBER_OF_ARTIFACT_QUERY_ATTEMPTS = 10;
const ADS_FILE = "lantern/assets/ads.js";

// From https://easylist.to/easylist/easylist.txt, used by AdBlock
const EASY_LIST_QUERY_PARAMS = [
  "ad_box_",
  "ad_type_",
  "advert_"
].join("&");

@Injectable()
export class AdBlockDetectorService {
  protected documentRef: Document;

  constructor(
    protected alertModalService: AlertModalService,
    @Inject(DOCUMENT) documentRef: any
  ) {
    this.documentRef = documentRef;
  }

  async assertDisabled(): Promise<void> {
    if (await this.hasAdBlocker()) {
      const modal = this.alertModalService.open({
        title: "Ad Blocker Detected",
        message:
          "Ad blockers interfere with core features of our site. Please disable your ad blocker to continue."
      });
      await modal.response.toPromise();

      this.documentRef.defaultView!.location.reload();
    }
  }

  private async hasAdBlocker(): Promise<boolean> {
    const artifactId = Math.round(Number.MAX_SAFE_INTEGER * Math.random()).toString(
      36
    );

    try {
      const src = `${ADS_FILE}?${EASY_LIST_QUERY_PARAMS}&id=${artifactId}`;
      const script = await this.injectScript(src);
      const artifact = await this.detectAdsScriptArtifact(artifactId);

      script.remove();
      artifact.remove();

      return false;
    } catch {
      return true;
    }
  }

  private injectScript(src: string): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
      const script = this.documentRef.createElement("script");
      script.src = src;
      script.onload = () => resolve(script);
      script.onerror = () => {
        script.remove();
        reject();
      };

      this.documentRef.body.appendChild(script);
    });
  }

  private detectAdsScriptArtifact(
    artifactId: string
  ): Promise<HTMLElement> {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        const elem = this.documentRef.getElementById(artifactId);
        if (elem == null) {
          return;
        }

        clearTimeout(timer);
        clearInterval(interval);

        resolve(elem);
      }, TIMEOUT_MS / NUMBER_OF_ARTIFACT_QUERY_ATTEMPTS);

      const timer = setTimeout(() => {
        clearInterval(interval);
        reject();
      }, TIMEOUT_MS);
    });
  }
}
